import { Model, UserModel } from '@descomplica/dex-models';
import { timeSinceCreation } from '@/helpers/date';
import { FileModel } from '../FileModel';

export interface CommentInfo {
  id: number;
  name: string | null;
  text: string;
  discussion: string;
  userId: number;
  score: number | null;
  createdAt: string;
  replies: number[];
  attachments: FileModel[];
}

export class CommentModel extends Model {
  id: number;

  name: string | null;

  text: string;

  discussionId: number;

  userId: number;

  score: number | null;

  createdAt: string;

  repliesId: number[];

  attachments: FileModel[];

  constructor(comment: CommentInfo, getters: unknown) {
    super(getters);
    this.id = comment.id;
    this.name = comment.name;
    this.text = comment.text;
    this.discussionId = parseInt(comment.discussion, 10);
    this.userId = comment.userId;
    this.score = comment.score;
    this.createdAt = comment.createdAt;
    this.score = comment.score;
    this.repliesId = comment.replies;
    this.attachments = comment.attachments;
  }

  get author(): UserModel {
    return this.getters.userById(this.userId);
  }

  get timeSinceCreation(): string {
    return timeSinceCreation(this.createdAt);
  }
}
